import { COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_6_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_6 } from './constantesReporteEmbarqueSector12Linea6'
import { TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_6 } from '../../../../../../config/tables'
import { ReporteEmbarqueSector12Linea6Service } from '../../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_12_linea_6'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_6
    })
    const promiseReporteEmbarqueSector12Linea6 = ReporteEmbarqueSector12Linea6Service.getDataReporteEmbarqueSector12Linea6(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector12Linea6Total = ReporteEmbarqueSector12Linea6Service.getDataReporteEmbarqueSector12Linea6Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector12Linea6, promiseReporteEmbarqueSector12Linea6Total]).then(callback)
    function callback (dataArray) {
      console.log(dataArray)
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1].filas || [])[0] || {}
      filaTotalArreglada['cereal'] = 'Total'
      filaTotalArreglada['pesoNetoBaseVigente'] = filaTotalArreglada['sum']
      console.log(filaTotalArreglada)
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Reporte Embarque Sector 1-2 Linea 6',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_6_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_6,
          data: dataCombinada,
          title: `Reporte Embarque Sector 1-2 Linea 6`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_6
      })
    }
  }
}
